<template>
  <a :href="href" :target="target" :rel="rel" class="card-link">
    <div class="hr-card">
      <div class="link-icon">
        <img v-if="isImage" :src="icon" :alt="label" />
        <i v-else :class="icon"></i>
      </div>
      <p><strong>{{ label }}</strong></p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'IconCard',
  props: {
    href: { type: String, default: '#' },
    target: { type: String, default: null },
    rel: { type: String, default: null },
    label: { type: String, default: '' },
    icon: { type: String, required: true }
  },
  computed: {
    isImage() {
      return /\.(svg|png|jpe?g|gif|webp)$/i.test(this.icon);
    }
  }
};
</script>

<style scoped>
.card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}
.hr-card {
  border-radius: 30px;
  border: solid 1px #D5D1C8;
  min-height: 180px;
  text-align: center;
  transition: .2s;
  padding: 0 .75em;
}
.hr-card:hover{
  background: #F9F8F6;
  border-color: #fff;
}
.link-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background: #E1DED8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: .5em auto 0;
  font-size: 2.5rem;
  color: #5F5E5B;
  box-sizing: border-box;
}
.link-icon img {
  max-height: 45px;
  max-width: 45px;
  width: 100%;
}
</style>